import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Payment() {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Get plan_id from query string
  const planId = new URLSearchParams(location.search).get('plan_id');

  useEffect(() => {
    if (!planId) {
      setError('No plan selected');
      setLoading(false);
      return;
    }
    api.get('/plans')
      .then(res => {
        const found = (res.data.plans || []).find(p => p.id === parseInt(planId));
        setPlan(found);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load plan');
        setLoading(false);
      });
  }, [planId]);

  const handlePayment = async () => {
    if (!plan) return;
    try {
      const res = await api.post('/payments/intent', { amount: plan.price, currency: 'usd' });
      setClientSecret(res.data.client_secret);
      // Here you would show Stripe Elements UI and confirm payment
      // On success, create subscription and redirect to dashboard
      // For now, just simulate success:
      setTimeout(() => navigate('/dashboard'), 2000);
    } catch (e) {
      setError('Payment failed');
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!plan) return <div>No plan found.</div>;

  return (
    <div className="container py-4">
      <h2>Payment for {plan.name}</h2>
      <div>Amount: ${plan.price}</div>
      <button className="btn btn-success mt-3" onClick={handlePayment} disabled={!!clientSecret}>
        {clientSecret ? 'Processing...' : 'Pay Now'}
      </button>
      {clientSecret && <div className="mt-3">Payment successful! Redirecting...</div>}
    </div>
  );
}

export default Payment;
